<template>
  <v-menu style="margin-top:12px;" class="menu-container" bottom left offset-y max-width="768">
    <button
      :class="`dt-button  s8`"
      style="
        margin-right: 5px;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        
      "
      slot="activator"
    >

      <span class="label-menu" style="width: 100%; padding: 2px"
        >{{ label }}</span
      >
      <span
        class="dt-icon-container"
        style="
          width: 20px;
          border-left: 1px solid var(--sprt-3);
          margin-right: -3px;
          height: 21px;
        "
      >
        <img
          src="static/icons/chevron-down.svg"
          alt="options"
          class="dt-icon s12p nohover"
        />
      </span>
    </button>
    <v-list class="filter-more-options-list">
      <v-list-tile
        class="options-item"
        v-for="(item, index) in options"
        :key="index"
        @click="(e) => onMenuItemClicked(item)"
      >
        <v-list-tile-title
          :class="{
            'ut-text-error': item.error ? true : false,
          }"
          >{{ item.text }}</v-list-tile-title
        >
      </v-list-tile>
    </v-list>
  </v-menu>
</template>
<script>
export default {
  props: ["options", "label"],
  methods: {
    onMenuItemClicked(item) {
      this.$emit("click", item);
    },
  },
};
</script>
<style <style lang="scss" scoped >
.list__tile__title:first-letter {
  text-transform: uppercase;
}
.label-menu:first-letter {
  text-transform: uppercase;
}
</style>

